import axios from 'axios';
import { logger } from '../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const getProducts = async (featured = false) => {
  try {
    const params = featured ? { featured: true } : {};
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  } catch (error) {
    logger.error('Error fetching products:', error);
    throw error;
  }
};

export const getProduct = async (productId) => {
  try {
    const response = await axios.get(`${API}/products/${productId}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching product:', error);
    throw error;
  }
};

// Colors API
export const getColors = async () => {
  try {
    const response = await axios.get(`${API}/colors`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching colors:', error);
    throw error;
  }
};

// FAQs API
export const getFAQs = async () => {
  try {
    const response = await axios.get(`${API}/faqs`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching FAQs:', error);
    throw error;
  }
};

// Cases API
export const getCases = async () => {
  try {
    const response = await axios.get(`${API}/cases`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching cases:', error);
    throw error;
  }
};

// Contact API
export const submitContact = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    logger.error('Error submitting contact:', error);
    throw error;
  }
};

// Orders API
export const createOrder = async (orderData) => {
  try {
    const response = await axios.post(`${API}/orders/`, orderData);
    return response.data;
  } catch (error) {
    logger.error('Error creating order:', error);
    throw error;
  }
};

export const getOrders = async () => {
  try {
    const response = await axios.get(`${API}/orders/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching orders:', error);
    throw error;
  }
};

export const getOrder = async (orderId) => {
  try {
    const response = await axios.get(`${API}/orders/${orderId}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching order:', error);
    throw error;
  }
};

export const updateOrderStatus = async (orderId, status) => {
  try {
    const response = await axios.patch(`${API}/orders/${orderId}/status`, null, {
      params: { status }
    });
    return response.data;
  } catch (error) {
    logger.error('Error updating order status:', error);
    throw error;
  }
};

// Payment API
export const createPayment = async (orderId, returnUrl) => {
  try {
    const response = await axios.post(`${API}/payment/create`, {
      order_id: orderId,
      return_url: returnUrl
    });
    return response.data;
  } catch (error) {
    logger.error('Error creating payment:', error);
    throw error;
  }
};

export const getPaymentStatus = async (paymentId) => {
  try {
    const response = await axios.get(`${API}/payment/status/${paymentId}`);
    return response.data;
  } catch (error) {
    logger.error('Error getting payment status:', error);
    throw error;
  }
};


// Discount API
export const validateDiscountCode = async (code, orderTotal) => {
  try {
    const response = await axios.post(`${API}/discounts/validate`, {
      code: code,
      order_total: orderTotal
    });
    return response.data;
  } catch (error) {
    logger.error('Error validating discount code:', error);
    throw error;
  }
};

export const applyDiscountCode = async (code) => {
  try {
    const response = await axios.post(`${API}/discounts/apply/${code}`);
    return response.data;
  } catch (error) {
    logger.error('Error applying discount code:', error);
    throw error;
  }
};

export const getAllDiscountCodes = async (token) => {
  try {
    const response = await axios.get(`${API}/discounts/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching discount codes:', error);
    throw error;
  }
};

export const createDiscountCode = async (discountData, token) => {
  try {
    const response = await axios.post(`${API}/discounts/`, discountData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    logger.error('Error creating discount code:', error);
    throw error;
  }
};

export const deleteDiscountCode = async (discountId, token) => {
  try {
    const response = await axios.delete(`${API}/discounts/${discountId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    logger.error('Error deleting discount code:', error);
    throw error;
  }
};

export const toggleDiscountCode = async (discountId, token) => {
  try {
    const response = await axios.patch(`${API}/discounts/${discountId}/toggle`, null, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    logger.error('Error toggling discount code:', error);
    throw error;
  }
};
